import React from 'react';
import {Tabs} from 'antd';
import AuditedList from './AuditedList.js';
const { TabPane } = Tabs;
class Audited extends React.Component{
  
    constructor(props) {
      super(props);  
      this.state={
        activeKey:"1"
      }
    }
      callback(activeKey,type,params){
          if(type == "details"){
            this.state.params = params
          }
          if(type == "add"){
            this.state.params = null
          }
        this.setState({activeKey:activeKey})
      }
    render(){
      const {isfalse}=this.state
        return(
          <div>
            <Tabs type="card" activeKey={this.state.activeKey} onChange= {this.callback.bind(this)}>
            <TabPane tab="已审核列表" key="1">
              <AuditedList  buttonList={this.props.buttonList} callback = {this.callback.bind(this)}/>
            </TabPane>
          </Tabs>
          </div>
        )
    }
}
export default Audited;